import { gql, useMutation } from '@apollo/client'
import type { GQL_ID } from '@@partner:types:graphql'

export interface DeleteRegionMutation {
  deleteRegion: boolean
}

export interface DeleteRegionVariables {
  id: GQL_ID
}

export const GQL_MUTATION_DELETE_REGION = gql`
  mutation deleteRegion($id: ID!) {
    deleteRegion(id: $id)
  }
`

export const useDeleteRegion = () =>
  useMutation<DeleteRegionMutation, DeleteRegionVariables>(GQL_MUTATION_DELETE_REGION)
